export {default as ApiBase} from './ApiBase';
export {default as getValidationErrorsFromModelState} from './getValidationErrorsFromModelState';
export {default as handleApiError} from './handleApiError';
export {default as http} from './http';
export {default as isSupportedDevice} from './isSupportedDevice';
export {default as mapSelectedOptionsToValues} from './mapSelectedOptionsToValues';
export {default as modelsArrayToMapById} from './modelsArrayToMapById';
export {default as getDisplayableShortGrade} from './getDisplayableShortGrade';
export {default as toFormData} from './toFormData';



// WEBPACK FOOTER //
// ./app/features/shared/services/index.js